import { render, staticRenderFns } from "./Calculette.vue?vue&type=template&id=4b2a2f06&scoped=true"
import script from "./Calculette.vue?vue&type=script&lang=js"
export * from "./Calculette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a2f06",
  null
  
)

export default component.exports